/**
 * Sends enterprise companies to /welcome when they must see it:
 *   - awaiting their first payment (everyone in the company), or
 *   - the owner / super admin hasn't seen the welcome page yet.
 * The server enforces the payment lock (402 ENTERPRISE_AWAITING_PAYMENT);
 * this only routes people to the right page.
 */
import { Navigate, useLocation } from "react-router-dom";
import useAuthStore from "@/stores/authStore";
import { useEnterprise } from "@/services/enterpriseService";

export default function EnterpriseGate() {
  const { data } = useEnterprise();
  const role = useAuthStore((s) => s.user?.role);
  const loc = useLocation();
  if (!data || !data.enterprise || loc.pathname.startsWith("/welcome")) return null;
  const firstVisit = !data.welcomeSeenAt && (role === "tenant_owner" || role === "super_admin");
  if (data.awaitingPayment || firstVisit) return <Navigate to="/welcome" replace />;
  return null;
}
